var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kundenportal-product-combos" },
    [
      _vm._l(_vm.groupedProducts, function (group) {
        return [
          _c(
            "div",
            { staticClass: "kpc__header" },
            [
              _vm.showDecor(group[0])
                ? [
                    _c("div", { staticClass: "kpc__header__label" }, [
                      _vm._v(_vm._s(_vm.$t("global-product-combo.decor"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__image",
                        attrs: { href: group[0].link_d },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: _vm.composeAltText([
                              group[0].title_d,
                              group[0].titlesuffix_d,
                              group[0].subtitle_d,
                            ]),
                            src: group[0].image_d_src,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__title",
                        attrs: { href: group[0].link_d },
                      },
                      [
                        _c("div", [
                          _c("strong", [_vm._v(_vm._s(group[0].title_d))]),
                          _vm._v(" " + _vm._s(group[0].titlesuffix_d)),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(group[0].subtitle_d))]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.showStructure(group[0])
                ? [
                    _c("div", { staticClass: "kpc__header__label" }, [
                      _vm._v(_vm._s(_vm.$t("global-product-combo.structure"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__image",
                        attrs: { href: group[0].link_s },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: _vm.composeAltText([
                              group[0].title_s,
                              group[0].titlesuffix_s,
                              group[0].subtitle_s,
                            ]),
                            src: group[0].image_s_src,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__title",
                        attrs: { href: group[0].link_s },
                      },
                      [
                        _c("div", [
                          _c("strong", [_vm._v(_vm._s(group[0].title_s))]),
                          _vm._v(" " + _vm._s(group[0].titlesuffix_s)),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(group[0].subtitle_s))]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.showProduct(group[0])
                ? [
                    _c("div", { staticClass: "kpc__header__label" }, [
                      _vm._v(_vm._s(_vm.$t("global-product-combo.panel"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__image",
                        attrs: { href: group[0].link_t },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: _vm.composeAltText([
                              group[0].title_t,
                              group[0].titlesuffix_t,
                              group[0].subtitle_t,
                            ]),
                            src: group[0].image_t_src,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__title",
                        attrs: { href: group[0].link_t },
                      },
                      [
                        _c("div", [
                          _c("strong", [_vm._v(_vm._s(group[0].title_t))]),
                          _vm._v(" " + _vm._s(group[0].titlesuffix_t)),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(group[0].subtitle_t))]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.showRawboard(group[0])
                ? [
                    _c("div", { staticClass: "kpc__header__label" }, [
                      _vm._v(_vm._s(_vm.$t("global-product-combo.rawboard"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__image",
                        attrs: { href: group[0].link_r },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: _vm.composeAltText([
                              group[0].title_r,
                              group[0].titlesuffix_r,
                              group[0].subtitle_r,
                            ]),
                            src: group[0].image_r_src,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "kpc__header__title",
                        attrs: { href: group[0].link_r },
                      },
                      [
                        _c("div", [
                          _c("strong", [_vm._v(_vm._s(group[0].title_r))]),
                          _vm._v(" " + _vm._s(group[0].titlesuffix_r)),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(group[0].subtitle_r))]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "kpc__subheader" }, [
            _c("div", { staticClass: "kpc__subheader__matnr" }, [
              _vm._v(_vm._s(_vm.$t("kundenportal-product-combos.matnr"))),
            ]),
            _vm._v(" "),
            !_vm.omitApplicationColumn
              ? _c("div", { staticClass: "kpc__subheader__application" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "kundenportal-product-combos.recommended_application"
                      )
                    )
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "kpc__subheader__dimension" }, [
              _vm._v(_vm._s(_vm.$t("kundenportal-product-combos.dimension"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "kpc__subheader__quantities_stock" }, [
              _vm._v(
                _vm._s(_vm.$t("kundenportal-product-combos.quantities_stock"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "kpc__subheader__quantities_production" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("kundenportal-product-combos.quantities_production")
                  )
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "kpc__subheader__check" },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("kundenportal-product-combos.check_title"))
                  ),
                ]),
                _vm._v(" "),
                _c("global-tooltip", [
                  _c("p", {
                    staticClass: "check-notice",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("kundenportal-product-combos.check_tooltip")
                      ),
                    },
                  }),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm._l(group, function (product, index) {
            return [
              _c("kundenportal-product-combo", {
                key: product.pim_id,
                class: { "kpc--last": index === group.length - 1 },
                attrs: {
                  product: product,
                  "omit-decor-colum": _vm.omitDecorColum,
                  "omit-structure-colum": _vm.omitStructureColum,
                  "omit-product-colum": _vm.omitProductColum,
                  "omit-rawboard-colum": _vm.omitRawboardColum,
                  "omit-application-column": _vm.omitApplicationColumn,
                },
              }),
            ]
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }